import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import GoBack from '@/components/common/go-back/GoBack';
import NoData from '@/components/common/no-data/NoData';
import FormAnnouncements from '@/components/forms/form-announcements/FormAnnouncements';
import { Skeleton } from '@/components/ui/skeleton';
import useEditAnnouncements from '@/hooks/pages/useEditAnnouncements';

const EditAnnouncements = () => {
  const {
    isLoading,
    isError,
    announcement,
    onSubmit,
    defaultValues,
    isPending
  } = useEditAnnouncements();

  if (isLoading) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-[332px]" />
      </>
    );
  }

  if (!announcement) {
    return (
      <>
        <GoBack />
        <NoData />
      </>
    );
  }

  if (isError) {
    return (
      <>
        <GoBack />
        <ErrorMessage />
      </>
    );
  }

  return (
    <>
      <GoBack />
      <div className="flex justify-center w-full">
        <FormAnnouncements
          onSubmit={onSubmit}
          isPending={isPending}
          isEdit={true}
          defaultValues={defaultValues}
          announcementId={announcement.id}
        />
      </div>
    </>
  );
};

export default EditAnnouncements;
